import Schedule from '../../components/schedule/schedule'
import Specializations from '../../components/specializations/specialization'
import Graduations from '../../components/graduations/graduations'
import companyStatitics from '../../components/statistics'
import Items from '../../components/Items/items'

export default {
  Schedule,
  Specializations,
  Graduations,
  Items,
  companyStatitics
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-professional/gadget/resources/components.js